import { normalizeLocation } from "./savedJobs.js";
import { ViewedJob } from "../model/ViewedJob.js";
import { composeCheckValidityApiUrl } from "./urlHandler.js";
import {Feature} from "@src/common/model/Feature";

export const initClickViewHistorySaver = () => {
    $('.s-biggerLink_wrap').on('click', (e) => saveViewHistoryFromSearch(e));
}

export const initClickViewHistorySaverForNearMe = () => {
    $('.s-biggerLink_wrap.s-job_panel').on('click', (e) => saveViewHistoryFromNearMe(e));
}

export const initClickViewHistorySaverForTopNearMe = () => {
    $('.s-biggerLink_wrap').on('click', (e) => saveViewHistoryFromTopNearMe(e));
}

export const initDirectViewHistorySaver = () => {
    $(window).on('pageshow', saveViewHistoryFromDetail);
}

const LOCAL_STORAGE_KEY = 'view_history';

const viewHistoryProps = [
    'addTime',
    'companyName',
    'features',
    'isFromJobPanel',
    'jobType',
    'location',
    'salary',
    'title',
    'uniqueId',
    'stationName',
    'trainList'
];

/**
 * 検索結果由来の閲覧履歴を保存
 *
 * @param {Event} e
 * @return {void}
 */
const saveViewHistoryFromSearch = (e) => {
    e.preventDefault();

    // 閲覧履歴に追加する求人データ取得
    const uniqueId = $(e.currentTarget).find('.s-biggerLink').attr('data-job-unique-id');
    const newViewedJobData = jobViewModelList.find(jobViewModel => jobViewModel.uniqueId === uniqueId);
    newViewedJobData['isFromJobPanel'] = true;

    // 正規化対象の勤務地表記を正規化 USのNeighborhoodの場合
    if (shouldNormalizeLocation) {
        newViewedJobData['location'] = normalizeLocation(newViewedJobData['location']);
    }

    // featureViewModelをfeaturesに変換
    newViewedJobData['features'] = convertFeatureViewModelToFeature(newViewedJobData['featureViewModel']);

    // 閲覧履歴リスト取得
    const viewHistory = addNewViewedJob(newViewedJobData);
    // 更新
    updateAll(viewHistory);
}

/**
 * Near Me ページ由来の閲覧履歴を保存
 *
 * @param {Event} e
 * @return {void}
 */
const saveViewHistoryFromNearMe = (e) => {
    e.preventDefault();

    // 閲覧履歴に追加する求人データ取得
    const uniqueId = $(e.currentTarget).find('.s-biggerLink').attr('data-job-unique-id');

    let newViewedJobData;
    for (let key in jobViewModelLists) {
        newViewedJobData = jobViewModelLists[key].find(jobViewModel => jobViewModel.uniqueId === uniqueId);
        if (newViewedJobData) {
            break;
        }
    }

    newViewedJobData['isFromJobPanel'] = true;

    // featureViewModelをfeaturesに変換
    newViewedJobData['features'] = convertFeatureViewModelToFeature(newViewedJobData['featureViewModel']);

    // 閲覧履歴リスト取得
    const viewHistory = addNewViewedJob(newViewedJobData);
    // 更新
    updateAll(viewHistory);
}

/**
 * TopページNearMe由来の閲覧履歴を保存
 *
 * @param {Event} e
 * @return {void}
 */
const saveViewHistoryFromTopNearMe = (e) => {
    e.preventDefault();

    // 閲覧履歴に追加する求人データ取得
    const uniqueId = $(e.currentTarget).find('.s-biggerLink').attr('data-job-unique-id');

    const newViewedJobData = jobViewModelList.find(jobViewModel => jobViewModel.uniqueId === uniqueId);

    newViewedJobData['isFromJobPanel'] = true;

    // featureViewModelをfeaturesに変換
    newViewedJobData['features'] = convertFeatureViewModelToFeature(newViewedJobData['featureViewModel']);

    // 閲覧履歴リスト取得
    const viewHistory = addNewViewedJob(newViewedJobData);
    // 更新
    updateAll(viewHistory);
}

/**
 * 閲覧履歴由来の閲覧履歴を保存
 *
 * @param {ViewedJob} job
 */
export const saveViewHistoryFromHistory = (job) => {
    job.isFromJobPanel = true;

    // 閲覧履歴リスト取得
    const viewHistory = addNewViewedJob(job);
    // 更新
    updateAll(viewHistory);
}

/**
 * 新しい閲覧履歴を追加
 *
 * @param job
 * @return {ViewedJob[]}
 */
export const addNewViewedJob = (job) => {
    const newViewedJob = new ViewedJob(job);

    // 閲覧履歴リスト取得
    const viewHistory = fetchViewHistory();

    // 既存の閲覧履歴に重複があれば削除
    const duplicatedJobIndex = viewHistory.findIndex(viewedJob => {
        return viewedJob.uniqueId === newViewedJob.uniqueId;
    });
    if (duplicatedJobIndex >= 0) {
        viewHistory.splice(duplicatedJobIndex, 1);
    }

    deleteExtraViewHistory(viewHistory);

    // 閲覧履歴リストにjobデータを追加
    viewHistory.unshift(newViewedJob);

    return viewHistory;
}

/**
 * 求人詳細由来の閲覧履歴を保存
 *
 * @return {void}
 */
const saveViewHistoryFromDetail = () => {
    // 閲覧履歴に追加する求人データ取得
    const newViewedJobData = jobData;
    newViewedJobData['isFromJobPanel'] = false;

    // 閲覧履歴リスト取得
    const viewHistory = fetchViewHistory();

    // 重複を探す
    const newViewedJobUniqueId = newViewedJobData['uniqueId'];
    let duplicatedJobIndex = -1;
    let isIgnored = false;
    viewHistory.forEach((viewedJob, index) => {
        if (viewedJob.uniqueId !== newViewedJobUniqueId) {
            return;
        }
        // 古い方が検索由来でないものは常に削除対象
        if (viewedJob.isFromJobPanel === false) {
            duplicatedJobIndex = index;
            return;
        }
        // 古い方が検索由来の場合、30秒以上前に保存されたものは削除対象
        if (Date.now() - viewedJob.addTime >= 30000 /* ms */) {
            duplicatedJobIndex = index;
            return;
        }
        // 古い方が検索由来かつ30秒以内に保存された場合は新しい方を無視する
        isIgnored = true;
    });

    // 検索→詳細と遷移したパターンなので閲覧履歴を更新せず終了
    if (isIgnored) {
        return;
    }

    // 重複削除対象があれば削除
    if (duplicatedJobIndex >= 0) {
        viewHistory.splice(duplicatedJobIndex, 1);
    }

    const newViewedJob = new ViewedJob(newViewedJobData);

    deleteExtraViewHistory(viewHistory);

    // 閲覧履歴リストにjobデータを追加
    viewHistory.unshift(newViewedJob);
    updateAll(viewHistory);
}

/**
 * ローカルストレージから閲覧履歴を取ってくる
 *
 * @return {ViewedJob[]}
 */
export const fetchViewHistory = () => {
    const viewHistoryJson = localStorage.getItem(LOCAL_STORAGE_KEY);
    const viewHistory = JSON.parse(viewHistoryJson);

    if (!Array.isArray(viewHistory)) {
        return [];
    }

    return validate(viewHistory);
}

/**
 * ローカルストレージを更新する
 *
 * @param {ViewedJob[]} viewHistory
 * @return {void}
 */
export const updateAll = (viewHistory) => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(viewHistory));
}

/**
 * 値が入っているかどうかのバリデーション
 *
 * @param {ViewedJob[]} viewHistory
 * @return {ViewedJob[]}
 */
const validate = (viewHistory) => {
    viewHistory.filter(viewedJob => {
        // Objectでない場合は除外
        if (!(viewedJob instanceof Object)) {
            return false;
        }

        // 必要なプロパティがない場合は除外
        viewHistoryProps.forEach((prop) => {
            if (!viewedJob.hasOwnProperty(prop)) {
                return false;
            }
        });

        // featuresがnullの場合は空配列に変換
        if (viewedJob.features === null) {
            viewedJob.features = [];
        }

        return true;
    });

    return viewHistory;
}

/**
 * 閲覧履歴が30件を超えないように削除
 *
 * @param {ViewedJob[]} viewHistory
 */
const deleteExtraViewHistory = (viewHistory) => {
    while (viewHistory.length >= 30) {
        viewHistory.pop();
    }
}

/**
 * 閲覧履歴を複数削除する
 *
 * @param {string[]} uniqueIdList
 * @return {void}
 */
const deleteViewedJobs = (uniqueIdList) => {
    if (uniqueIdList.length === 0) {
        return;
    }

    const viewHistory = fetchViewHistory();

    // 削除対象のリストに入っていないものだけ残す
    const reducedViewHistory = viewHistory.filter(viewedJob => {
        return !uniqueIdList.some(uniqueId => uniqueId === viewedJob.uniqueId);
    });

    updateAll(reducedViewHistory);
}

/**
 * 求人の有効性をチェックして無効の場合は削除する
 *
 * @param {ViewedJob[]} viewHistory
 * @return {Promise<void>}
 */
export const checkValidity = async (viewHistory) => {
    if (viewHistory.length === 0) {
        return;
    }

    try {
        const response = await fetch(composeCheckValidityApiUrl(viewHistory));
        const result = await response.json();
        const invalidUniqueIdList = [];

        for (const viewedJob of viewHistory) {
            const uniqueId = viewedJob.uniqueId;

            // { uniqueId_1: bool, uniqueId_2: bool, ... }
            if (result.validityList[uniqueId] === false) {
                invalidUniqueIdList.push(uniqueId);
            }
        }

        // 無効求人の削除
        deleteViewedJobs(invalidUniqueIdList);
    } catch (err) {
        console.log(err);
    }
}

/**
 * @param {object} featureViewModel
 * @return {Feature}
 */
const convertFeatureViewModelToFeature = (featureViewModel) => {
    return new Feature(featureViewModel);
}
